/* The externally injected customer-trust graphic repeats its adjacent text. */
(() => {
  const fix = root => {
    if (!(root instanceof Element || root instanceof Document)) return;
    const images = [...root.querySelectorAll('.trusted img:not([alt])')];
    if (root instanceof Element && root.matches('.trusted img:not([alt])')) images.push(root);
    images.forEach(image => image.setAttribute('alt', ''));
  };
  fix(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(fix)))
    .observe(document.body, {childList: true, subtree: true});
})();
